import { Outlet } from "react-router-dom";
import { Page } from "../page-base";
import { ColumnContainer, RowContainer } from "./styles";
import AppSidebar from "../side-bar";

export const NavTab: React.FC = () => {
  return (
    <ColumnContainer>
      <Page.CHeader />
      <RowContainer>
        <AppSidebar />
        <Outlet />
      </RowContainer>
    </ColumnContainer>
  );
};
